import decodeToken from "jwt-decode";
import _isEmpty from "lodash/isEmpty";
import { atom, selector } from "recoil";

import { getInitialRangeDate, getToken, removeToken } from "./helpers";

export const filterKotaforJobsAtom = atom({
  key: "filterKotaforJobsAtom",
  default: [],
});

export const globalSuccessAtom = atom({
  key: "globalSuccessAtom",
  default: false,
});

export const globalModalOpenAtom = atom({
  key: "globalModalOpenAtom",
  default: false,
});

export const masterStatusCandidate = atom({
  key: "masterStatusCandidate",
  default: [],
});

export const getDetailJobByCandidateID = atom({
  key: "getDetailJobByCandidateID",
  default: [],
});

export const filterJobAtom = atom({
  default: [],
  key: "filterJobAtom",
});

export const authTokenAtom = atom({
  default: getToken(),
  key: "authTokenAtom",
});

export const globalLoadingAtom = atom({
  default: false,
  key: "globalLoadingAtom",
});

export const globalLoadingScreenAtom = atom({
  default: false,
  key: "globalLoadingScreenAtom",
});

export const globalLoadingNonScreenAtom = atom({
  default: false,
  key: "globalLoadingNonScreenAtom,"
})

export const userDataSelector = selector({
  get: ({ get }) => {
    const token = get(authTokenAtom);
    try {
      if (!token) {
        throw new Error("");
      } else {
        const decodedToken = decodeToken(token);
        return decodedToken.data;
      }
    } catch (error) {
      removeToken();
      // window.location.reload();
      return null;
    }
  },
  key: "userDataSelector",
});

export const isLoggedInSelector = selector({
  key: "isLoggedInSelector",
  get: ({ get }) => {
    return !_isEmpty(get(userDataSelector));
  },
});

export const isEmbededAtom = atom({
  default: false,
  key: "isEmbededAtom",
});
export const intervalTimeAtom = atom({
  default: getInitialRangeDate(), // {start:'31/01/2021',end:'31/01/2021'}
  key: "intervalTimeAtom",
});

export const routeHistoryAtom = atom({
  default: [],
  key: "routeHistoryAtom",
});

export const errInputAtom = atom({
  default: false,
  key: "errInputAtom",
})
